import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import {
    BarChartIcon,
    CloseIcon,
    colors
} from "@dotnet/telematics-design-system";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import RoutesContext from "context/routes/routesContext";

import { DrawerLabelProps } from "./types";

export const DrawerLabel = ({
    scrollTop,
    permanentBorder
}: DrawerLabelProps) => {
    const { gray200, gray700, white } = colors;

    const { toggleStatistics } = useContext(RoutesContext);

    const { t } = useTranslation();

    return (
        <div
            data-testid="drawer-label"
            css={css({
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: white,
                padding: "16px 16px 15px 16px",
                borderBottom:
                    (scrollTop && scrollTop > 0) || permanentBorder
                        ? `1px solid ${gray200}`
                        : "1px solid transparent"
            })}
        >
            <div
                css={css({
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                })}
            >
                <BarChartIcon />

                <div
                    css={css({
                        fontWeight: "500",
                        fontSize: "14px",
                        lineHeight: "20px",
                        letterSpacing: "0.1px",
                        paddingLeft: "8px",
                        color: gray700
                    })}
                >
                    {t("Statistics##table statistics")}
                </div>
            </div>

            <Button
                color={BUTTON_COLORS.White}
                size={BUTTON_SIZES.Tiny}
                variant={BUTTON_VARIANTS.IconOnly}
                icon={<CloseIcon />}
                onClick={toggleStatistics}
            />
        </div>
    );
};
